// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarFormasPagamentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/buscar_formas_pagamento
 *
 * Sem corpo: o catálogo global de formas de pagamento. Com franquia_id: cada forma como vale
 * naquela franquia (chamado 2026-0023).
 */
import { registerContract } from './validate'

export interface Agenda_BuscarFormasPagamentoInput {
franquia_id?: number
}

registerContract('Agenda_BuscarFormasPagamentoInput', {
  franquia_id: { type: 'number',  required: false },
})
